import { getStorageUrl } from "../../../config/config";
import Swal from "sweetalert2";
import { getTipoDocumentoTexto } from "../../../components/utils/invoiceValidation";

export default function InvalidacionModal({
  show,
  invoice,
  invalidacion,
  loading,
  onDescargar, // 🆕 NUEVO - recibir función desde el padre
  isDownloading, // 🆕 NUEVO - estado de descarga
  onClose
}) {
  if (!show || !invoice) return null;

  // 🆕 NUEVA función que usa la función del padre
  const handleDescargarJsonInvalidacion = () => {
    if (!invalidacion?.json_invalidacion_path) {
      return Swal.fire("Error", "No hay JSON de invalidación disponible", "warning");
    }

    // Usar la función del padre que maneja la autenticación correctamente
    onDescargar(invoice);
  };

  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card">

            {/* Header */}
            <div className="card-header" style={{ 
              background: '#dbeafe', 
              borderBottom: '2px solid #3b82f6',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 className="card-title" style={{ margin: 0, color: '#1e40af' }}>
                🔍 Detalles de Anulación
              </h3>
              <button
                className="btn btn-secondary btn-sm"
                onClick={onClose}
                style={{ 
                  width: '32px', 
                  height: '32px', 
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="card-body">
              {loading ? (
                <div className="text-center" style={{ padding: '40px 0' }}>
                  <div className="spinner"></div>
                  <p className="mt-2">Cargando información...</p>
                </div>
              ) : invalidacion ? (
                <>
                  {/* Info de la factura */}
                  <div style={{
                    background: '#f3f4f6',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px'
                  }}>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'auto 1fr',
                      gap: '8px 12px',
                      fontSize: '14px'
                    }}>
                      <strong>Factura:</strong>
                      <span>{invoice.numero_control}</span>
                      
                      <strong>Cliente:</strong>
                      <span>{invoice.sale?.client?.nombre || "N/A"}</span>
                      
                      <strong>Tipo:</strong>
                      <span>{getTipoDocumentoTexto(invoice.tipo_documento)}</span>
                      
                      <strong>Fecha emisión:</strong>
                      <span>{new Date(invoice.fecha_emision).toLocaleDateString('es-SV')}</span>
                    </div>
                  </div>

                  {/* Info de la anulación */}
                  <div style={{
                    background: '#fef3c7',
                    border: '1px solid #f59e0b',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px'
                  }}>
                    <h4 style={{ 
                      fontSize: '16px', 
                      fontWeight: 600, 
                      marginBottom: '12px',
                      color: '#92400e'
                    }}>
                      📋 Datos de Anulación
                    </h4>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'auto 1fr',
                      gap: '8px 12px',
                      fontSize: '14px'
                    }}>
                      <strong>Fecha anulación:</strong>
                      <span>
                        {new Date(invalidacion.fecha_anulacion).toLocaleDateString('es-SV')} {invalidacion.hora_anulacion}
                      </span>
                      
                      <strong>Responsable:</strong>
                      <span>{invalidacion.nombre_responsable}</span>
                      
                      <strong>Tipo:</strong>
                      <span>{invalidacion.tipo_anulacion === 1 ? 'Anulación' : 'Sustitución'}</span>
                      
                      <strong>Estado:</strong>
                      <span className={`badge ${
                        invalidacion.estado === 'procesado' ? 'badge-success' : 
                        invalidacion.estado === 'rechazado' ? 'badge-danger' : 
                        'badge-warning'
                      }`}>
                        {invalidacion.estado.toUpperCase()}
                      </span>
                    </div>
                  </div>

                  {/* Motivo */}
                  <div style={{
                    background: '#fff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px'
                  }}>
                    <h4 style={{ 
                      fontSize: '16px', 
                      fontWeight: 600, 
                      marginBottom: '12px'
                    }}>
                      📝 Motivo de Anulación
                    </h4>
                    <p style={{ 
                      margin: 0, 
                      fontSize: '14px',
                      lineHeight: '1.6',
                      color: '#374151'
                    }}>
                      {invalidacion.motivo_anulacion}
                    </p>
                  </div>

                  {/* Sello de Hacienda */}
                  {invalidacion.sello_invalidacion && (
                    <div style={{
                      background: '#d1fae5',
                      border: '1px solid #10b981',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '20px'
                    }}>
                      <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                        <span style={{ fontSize: '20px' }}>✅</span>
                        <div style={{ flex: 1 }}>
                          <strong style={{ 
                            color: '#065f46', 
                            display: 'block', 
                            marginBottom: '4px',
                            fontSize: '14px'
                          }}>
                            Sello de Recepción (Hacienda)
                          </strong>
                          <code style={{ 
                            fontSize: '12px',
                            wordBreak: 'break-all',
                            color: '#047857'
                          }}>
                            {invalidacion.sello_invalidacion}
                          </code>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center" style={{ padding: '40px 0' }}>
                  <p>No se encontró información de anulación</p>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="card-body" style={{ 
              borderTop: '2px solid #e2e8f0',
              display: 'flex',
              gap: '12px',
              paddingTop: '16px'
            }}>
              <button
                className="btn btn-secondary"
                onClick={onClose}
                style={{ flex: 1 }}
              >
                Cerrar
              </button>

              {invalidacion?.json_invalidacion_path && (
                <button
                  className="btn btn-primary"
                  onClick={handleDescargarJsonInvalidacion}
                  disabled={isDownloading} // 🆕 Deshabilitar mientras descarga
                  style={{ flex: 1 }}
                >
                  {isDownloading ? '⏳ Descargando...' : '📥 Descargar JSON Invalidación'}
                </button>
              )}
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}